import { Component, OnInit } from '@angular/core';
import { HttpService } from '../shared/http.service';
import { TransactionResponse, ConsultationResponse, ReservationResponse } from '@builtbybros/al-model';
import { QueryParam } from '../shared/query-param';
import moment = require('moment');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  title = 'Resumen';

  /**
   * endpoints structure:
   * endpoints[0] = consultations
   * endpoints[1] = consignee reservations
   * endpoints[2] = school reservations
   * endpoints[3] = transactions
   * endpoints[x][0] = endpoint to hit
   * endpoints[x][1] = natural language endpoint (table title)
   * endpoints[x][2] = true if retrieved data (like booksReady, etc)
   * endpoints[x][3] = retrieved objects (eg. Consultation.All)
   * endpoints[x][4] = columns to show into table
   */
  endpoints = [
    [
      'consultation',
      'Consultas',
      false,
      {},
      [
        ['phone', 'Teléfono'],
        ['email', 'Email'],
        ['updatedAt', 'Fecha'],
        ['status', 'Status']
      ]
    ],
    [
      'reservation',
      'Reservas de consignatarios',
      false,
      {},
      [
        ['companyName', 'Empresa', false], // userid.companyName
        ['contactName', 'Nombre Contacto', false], // userid.contactName
        ['initialDate', 'Fecha Inicial', false],
        ['expirationDate', 'Válido hasta', false],
        ['status', 'Estado']
      ]
    ],
    [
      'reservation',
      'Reservas de Escuelas',
      false,
      {},
      [
        ['instituteName', 'Empresa', false], // userid.companyName
        ['contactName', 'Nombre Contacto', false], // userid.contactName
        ['initialDate', 'Fecha Inicial', false],
        ['expirationDate', 'Válido hasta', false],
        ['status', 'Estado']
      ]
    ],
    [
      'transaction',
      'Compras',
      false,
      {},
      [
        ['createdAt', 'Fecha'],
        ['user', 'Usuario'],
        ['email', 'Correo'],
        ['pay', 'Pago'],
        ['amount', 'Total'],
        ['delivered', 'Estado']
      ]
    ]
  ];

  states = [
    [0, 'Todos'],
    [1, 'Pendiente'],
    [2, 'Aceptado'],
    [3, 'Rechazado'],
    [4, 'Cancelado'],
    [5, 'Entregado'],
    [6, 'Expirado']
  ];

  paymentStatus = {
    'pending': 'Pendiente', // The user has not yet completed the payment process
    'approved': 'Aprobado', // The payment has been approved and accredited
    'in_process': 'En Proceso', // Payment is being reviewed
    'in_mediation': 'En disputa', // Users have initiated a dispute
    'rejected': 'Rechazado', // Payment was rejected. The user may retry payment.
    'cancelled': 'Cancelado', // Payment was cancelled by one of the parties or because time for payment has expired
    'refunded': 'Devuelto', // Payment was refunded to the user
    'charged_back': 'Charged Back' // Was made a chargeback in the buyer’s credit card
  };

  constructor(private httpService: HttpService) { }


  ngOnInit() {
    this.fillTables();
  }


  fillTables() {
    const params = new Array<QueryParam>();
    params[0] = new QueryParam('pagination', '5');
    params[1] = new QueryParam('offset', '0');
    params[2] = new QueryParam('order', '-id');

    // this.endpoints[0] -> consultation
    this.httpService.getWithParams(`/${this.endpoints[0][0]}/All`, params, ConsultationResponse.All)
      .subscribe(
        response => {

          this.endpoints[0][2] = true;
          this.endpoints[0][3] = response;
          for (const c of this.endpoints[0][3]['objects']) {
            c['updatedAt'] = moment(c['updatedAt']).format('DD/MM/YYYY HH:mm');
            c['color-cell'] = (c['status'] === 'Resuelto') ? 'success' : 'danger';
          }
        }
      );
    const categoryParam = params;
    // category=3 -> consignees
    categoryParam[3] = new QueryParam('category', '3');
    // this.endpoints[1] -> reservation
    this.httpService.getWithParams(`/${this.endpoints[1][0]}/All`, categoryParam, ReservationResponse.All)
      .subscribe(
        response => {
          this.endpoints[1][2] = true;
          this.endpoints[1][3] = response;
          for (const c of this.endpoints[1][3]['objects']) {
            c['initialDate'] = moment(c['initialDate']).format('DD/MM/YYYY HH:mm');
            c['expirationDate'] = moment(c['expirationDate']).format('DD/MM/YYYY HH:mm');
            c['companyName'] = c['user']['companyName'];
            c['contactName'] = `${c['user']['name']} ${c['user']['lastName']}`;
            c['status'] = this.states[c['status']][1];
            c['color-cell'] = (c['status'] === 'Aceptado') ? 'success' : 'danger';
          }
        }
      );
    // category=4 -> schools
    categoryParam[3] = new QueryParam('category', '4');
    // this.endpoints[0] -> reservation
    this.httpService.getWithParams(`/${this.endpoints[2][0]}/All`, categoryParam, ReservationResponse.All)
      .subscribe(
        response => {
          this.endpoints[2][2] = true;
          this.endpoints[2][3] = response;
          for (const c of this.endpoints[2][3]['objects']) {
            c['initialDate'] = moment(c['initialDate']).format('DD/MM/YYYY HH:mm');
            c['expirationDate'] = moment(c['expirationDate']).format('DD/MM/YYYY HH:mm');
            c['instituteName'] = c['user']['instituteName'];
            c['contactName'] = `${c['user']['name']}`;
            c['status'] = this.states[c['status']][1];
            c['color-cell'] = (c['status'] === 'Aceptado') ? 'success' : 'danger';
          }
        }
      );
    // this.endpoints[0] -> transactions
    this.httpService.getWithParams(`/${this.endpoints[3][0]}/All`, params, TransactionResponse.All)
      .subscribe(
        response => {
          this.endpoints[3][2] = true;
          this.endpoints[3][3] = response;
          for (const c of this.endpoints[3][3]['objects']) {
            c['createdAt'] = moment(c['createdAt']).format('DD/MM/YYYY HH:mm');
            c['user'] = `${c['customerName']} ${c['customerLastName']}`;
            c['email'] = `${c['customerEmail']}`;
            c['delivered'] = (c['delivered']) ? 'Entregado' : 'Pendiente';
            // if c['pay'] != null then finish payment process
            c['pay'] = c['pay'] ? this.paymentStatus[c['pay']['status']] : 'No finalizado';
            c['color-cell'] = (c['delivered'] === 'Entregado') ? 'success' : 'danger'; //TODO: view if payment status defines cell color
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts